var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M27.7863 16C25.6825 16 23.977 17.7909 23.977 20C23.977 20.3338 24.0159 20.6581 24.0893 20.9681C22.0664 20.9681 19.0194 20.5591 16.4747 18.0096C16.1363 17.6706 15.5123 17.8973 15.5358 18.3757C15.9129 26.0627 19.205 28.3049 20.9003 28.4444C19.8056 29.5257 18.2153 30.3791 16.6151 30.7622C16.1928 30.8633 16.0885 31.3256 16.5014 31.4599C17.6465 31.8323 19.2854 31.9758 20.1676 32C26.4084 32 31.4809 26.7471 31.5938 20.2223C32.4131 19.6894 32.938 18.5325 33.2329 17.7129C33.3047 17.5133 32.9775 17.2807 32.7817 17.3623C32.1696 17.6171 31.3926 17.6775 30.7306 17.4618C30.032 16.5693 28.9725 16 27.7863 16Z",
    fill: "url(#paint0_linear_13711_154106)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13711_154106",
    x1: 19.894,
    y1: 30.6838,
    x2: 49.9759,
    y2: -6.19097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cb7bcac1b6b3deb6ee0b5676558b697d.svg";
export { ForwardRef as ReactComponent };